(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motowinn-aesthetic-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mw-brand-marquee')) {
  customElements.define('mw-brand-marquee', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || this.dataset.motion !== 'true') return;
      const track = this.querySelector('.mw-brand-track');
      const original = this.querySelector('.mw-brand-group');
      const button = this.querySelector('.mw-brand-toggle');
      if (!track || !original || !button) return;
      this.initialized = true;
      this.button = button;
      this.copy = original.cloneNode(true);
      this.copy.setAttribute('aria-hidden', 'true');
      this.copy.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
      track.appendChild(this.copy);
      this.dataset.enhanced = 'true';
      button.hidden = false;
      this.onToggle = () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? 'Resume motion' : 'Pause motion';
      };
      button.addEventListener('click', this.onToggle);
      if ('IntersectionObserver' in window) {
        this.dataset.offscreen = 'true';
        this.observer = new IntersectionObserver(entries => {
          this.dataset.offscreen = String(!entries[0].isIntersecting);
        });
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onToggle);
      this.copy?.remove();
      if (this.button) {
        this.button.hidden = true;
        this.button.setAttribute('aria-pressed', 'false');
        this.button.textContent = 'Pause motion';
      }
      delete this.dataset.enhanced;
      delete this.dataset.paused;
      delete this.dataset.offscreen;
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
